"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChargingPole = function IconChargingPole(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "m36.651 6.527-1.853 1.855 1.339 1.341 1.82-1.82 1.411 1.414-1.82 1.82 1.4 1.4-2.521 2.525a4.99 4.99 0 0 1-5.94.838 2.64 2.64 0 0 0 .34 2.919l.142.153 4.134 4.14-.01.01.152.16a3.914 3.914 0 0 1-2.915 6.522c-.963 0-1.89-.356-2.603-.995l-.16-.152-4.598-4.604v18.948h-1.997V16a3 3 0 0 0-2.82-2.996L19.975 13h-5.994a3 3 0 0 0-2.99 2.824l-.006.176v27H8.99V16a5 5 0 0 1 4.777-4.996l.216-.003h5.994a4.997 4.997 0 0 1 4.989 4.782l.004.217v5.42l.097-.097 5.913 5.92a1.91 1.91 0 0 0 2.703-.001 1.91 1.91 0 0 0 .114-2.58l-.114-.124.01-.011-4.135-4.14-.17-.178a4.644 4.644 0 0 1-.443-5.63 5.004 5.004 0 0 1 .42-6.589l2.522-2.524 1.5 1.502 1.853-1.855zM16.978 26l3.996-1-5.494 10 1.499-7-3.996 1 5.494-10zm13.8-16.595a3.004 3.004 0 0 0-.02 4.223l.14.133a2.995 2.995 0 0 0 4.117-.114l1.108-1.11-4.237-4.242z"
  })));
};

export { IconChargingPole, IconChargingPole as default };
